import ModalRegistration from './modalRegistration';

export default ModalRegistration;